import React, { useState } from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import ProfileUpdate from './ProfileUpdate';
import UpdatePassword from './UpdatePassword';

function ProfileTabs() {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };

    return (
        <Box
            sx={{
                width: '100%',
                maxWidth: '800px',
                margin: '0 auto', // Centers the tabs horizontally
                backgroundColor: '#ffffff', // White background
                borderRadius: '12px', // Slightly rounded edges for better appearance
            }}
        >
            {/* Tabs */}
            <Tabs
                value={activeTab}
                onChange={handleTabChange}
                variant="fullWidth"
                indicatorColor="primary"
                textColor="primary"
                sx={{
                    marginBottom: '2rem',
                }}
            >
                <Tab label="Profile Update" />
                <Tab label="Update Password" />
            </Tabs>

            {/* Tab Content */}
            <Box>
                {activeTab === 0 && <ProfileUpdate />}
                {activeTab === 1 && <UpdatePassword />}
            </Box>
        </Box>
    );
}

export default ProfileTabs;
